export interface UserRole {
  name: RoleType;
}

export const roles = {
  ADMIN: 'ADMIN',
  ANIMATION: 'ANIMATION',
  OPERATION: 'OPERATION',
  ADMIN_HEADQUARTER: 'ADMIN_HEADQUARTER',
  ANIMATION_HEADQUARTER: 'ANIMATION_HEADQUARTER',
  SUPERVISION: 'SUPERVISION',
  SUPERVISION_HEADQUARTER: 'SUPERVISION_HEADQUARTER',
} as const;

export type RoleType = (typeof roles)[keyof typeof roles];

export const OFFER_ROLES: RoleType[] = ['ADMIN', 'ANIMATION', 'OPERATION'];

export const HEADQUARTER_ROLES: RoleType[] = ['ADMIN_HEADQUARTER', 'ANIMATION_HEADQUARTER', 'SUPERVISION_HEADQUARTER'];
